import baseService from "@common/services/base.service";
import store from "@common/store/store";

const defaultRoute = window.api_routes.smarAPD_Common;

let http = baseService(store);

const apiDef = {
  getConfiguracaoGrid(user, idSistema) {
    return http.get(defaultRoute + `/Usuario/${user}/Sistema/${idSistema}/ConfiguracaoGrid`);
  },
  createConfiguracaoGrid({ user, idSistema, filter }) {
    return http.post(defaultRoute + `/Usuario/${user}/Sistema/${idSistema}/ConfiguracaoGrid`, filter);
  },
  updateConfiguracaoGrid({ user, idSistema, filter }) {
    return http.put(defaultRoute + `/Usuario/${user}/Sistema/${idSistema}/ConfiguracaoGrid`, filter);
  }
};

export default apiDef;
